import React, { Component } from "react";
import logo from "../../images/bp-logo.svg";
import {ClinicSelectList, RelatedClinics, ClinicDoctors} from "../../components/DataSelectList";
import NameSelectList from "../../components/NameSelectList";
import './Header.css';
import DateSelectorView from '../../views/DateSelectorView';
import IconWithCaption from "../../components/IconWithCaption";
import ItemToggle from "../../components/ItemToggle";

import { Popup } from 'semantic-ui-react';

import HelpDialog from '../HelpDialog';
import ClinicService from "../../api/services/ClinicService";

export class Header extends Component{

	constructor(props){
		super(props);
		this.state = {};
		this.account = props.account;
		this.clinic = new ClinicService();
		this.handleClinicChange = this.handleClinicChange.bind(this);
		this.handleDoctorChange = this.handleDoctorChange.bind(this);
		this.handleActionClick = this.handleActionClick.bind(this);
	}

	handleClinicChange(v){
		// this.state.currentDoctor = null;
		if(!this.state.clinicIsLoading) {
			ClinicService.ClearAllClinicCache();
			this.setState({currentDoctor: null, clinicIsLoading: true});
			console.log('Handle Clinic Change:', v)
			if (this.props.onClinicChange) {
				this.props.onClinicChange(v);
			}
			/*
           this.clinic.getInfo(v).then(() => {
               console.log("!!!!!Clinic Info Loaded wtf:", v)
               ClinicService.LoadDoctorSchedules(v).then(() => {
                   this.setState({clinicIsLoading: false});
                   if (this.props.onClinicChange) {
                       this.props.onClinicChange(v);
                   }
               });
           })
        */
		}
	}

	handleDoctorChange(v){
		if(this.props.onDoctorChange){
			this.props.onDoctorChange(v);
		}
	}

	handleActionClick(action, value){
		console.log("Header handleActionclick:", action)
		if(this.props.onActionClick){
			this.props.onActionClick(action, value);
		}
	}

	updateHeader(header){
		this.setState({sectionHeader:header});
	}

	render(){
		//console.log("Clicic Id:", this.props.clinicId);
		return(
			<div className="appointment-header table hmax align-middle">
				<div>
					<div>
						<img className='logo' src={logo} alt="" />
					</div>
					<div><RelatedClinics onChange={this.handleClinicChange} isLoading={this.state.clinicIsLoading} /></div>
					<div className='section-header hmax'>{this.state.sectionHeader}</div>
					<div><a href="http://learn.bioped.com/resources" target="am-bioped-help" style={{color:'inherit'}}><IconWithCaption icon='help' caption='help' className='header-help-btn' /*onClick={()=>this.setState({showHelp:true})}*/  /></a></div>
				</div>
				<HelpDialog isOpen={this.state.showHelp} onRequestClose={() => this.setState({showHelp:false})}/>
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/views/Appointments/Header.js